export function appendOnce(parent, selector) {
	let bits = selector.split(".");
	let child = parent.selectAll(selector).data([0]);
	return child.enter().append(bits[0]).attr("class", bits.slice(1).join(" "));
}
